/**
 * Lê um cookie de primeira parte pelo nome. Devolve `null` quando não existe — que é o caso normal
 * de `_fbp`/`_fbc` (GUE-315): comprador que não veio de anúncio não tem `_fbc`, e bloqueador de
 * anúncio impede o pixel de gravar os dois.
 *
 * O valor é decodificado porque o `_fbc` carrega o `fbclid` da URL, que pode vir percent-encoded.
 */
export function lerCookie(nome: string): string | null {
  if (typeof document === 'undefined' || !document.cookie) {
    return null;
  }

  const prefixo = `${nome}=`;
  for (const parte of document.cookie.split(';')) {
    const cookie = parte.trim();
    if (cookie.startsWith(prefixo)) {
      const valor = cookie.slice(prefixo.length);
      return valor === '' ? null : decodeURIComponent(valor);
    }
  }

  return null;
}
